import { Component, OnInit, Input } from '@angular/core';
import { ILicenseDataDetail } from '../licenses-page/licenses.page.component';

@Component({
  selector: 'nrwl-license-card',
  templateUrl: './license.card.template.html',
  styleUrls: ['./license.card.style.scss']
})
export class LicenseCardComponent implements OnInit {
  @Input() license: ILicenseDataDetail;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit() {}
}
